import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-general',
  templateUrl: './handover-general.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverGeneralComponent implements OnInit {

  @Input() model?: HandoverModel;

  get hasDescOrImages(): boolean {
    const hasDesc = this.model?.general?.desc != null && this.model!.general!.desc!.length > 0;
    const hasImages = this.model?.general?.imageUrls != null && this.model!.general!.imageUrls!.length > 0;
    return hasDesc || hasImages;
  }

  constructor() {
  }

  ngOnInit(): void {
  }
}
